export interface Translation {
  language?: string;
  value?: string;
}

export function getTranslationByLanguage(
  translations: Translation[] | undefined,
  language: string | undefined,
): Translation | undefined {
  return translations?.find(translation => translation?.language === language);
}
